"use strict";

var _objectWithoutProperties = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var confirmation_modal_content_module_scss_1 = __importDefault(require("./confirmation-modal-content.module.scss"));

var confirmation_button_box_component_1 = __importDefault(require("../confirmation-button-box/confirmation-button-box.component"));

var ConfirmationModalContent = function ConfirmationModalContent(_ref) {
  var description = _ref.description,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'キャンセル' : _ref$cancelText,
      _ref$confirmText = _ref.confirmText,
      confirmText = _ref$confirmText === void 0 ? '確認' : _ref$confirmText,
      errorMessage = _ref.errorMessage,
      otherProps = _objectWithoutProperties(_ref, ["description", "cancelText", "confirmText", "errorMessage"]);

  return react_1.default.createElement("div", {
    className: confirmation_modal_content_module_scss_1.default.container
  }, description && react_1.default.createElement("h2", {
    className: confirmation_modal_content_module_scss_1.default.title
  }, description), react_1.default.createElement(confirmation_button_box_component_1.default, Object.assign({
    cacelText: cancelText,
    confirmText: confirmText
  }, otherProps)), errorMessage && react_1.default.createElement("p", {
    className: confirmation_modal_content_module_scss_1.default.errorMessage
  }, errorMessage));
};

exports.default = ConfirmationModalContent;